if(customElements.get('product-form') === undefined) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();   
  
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
      this.stickyBtn = document.querySelector('.js-sticky-button') || null;
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');
    }
  
    onSubmitHandler(evt) {
      evt.preventDefault();
  
      // this.submitButton.setAttribute('disabled', true);
      // this.submitButton.classList.add('loading');
      
      // if(this.stickyBtn){
      //   this.stickyBtn.setAttribute('disabled', true);
      //   this.stickyBtn.classList.add('loading');  
      // }

      // let serializeFormJson = JSON.parse(serializeForm(this.form));
      
      // let checkInstallationProduct = (document.querySelector('#upsellInstallation')) ? document.querySelector('#upsellInstallation').checked : false;
      // let checkBundleUpsellProduct = (document.querySelector('#bundleupsellproduct')) ? document.querySelector('#bundleupsellproduct').checked : false;
      
      // let body = {
      //   ...serializeFormJson,
      //   sections: this.getSectionsToRender().map((section) => section.section),
      //   sections_url: window.location.pathname
      // };
  
      // if(checkInstallationProduct){
      //   let hiddenInstallationProduct = document.querySelector('#upsellInstallation'),
      //       uniqId = new Date().getTime();
      //   let mainProductFormData = serializeFormJson;
      //   let cartItems = {
      //     sections: this.getSectionsToRender().map((section) => section.section),
      //     sections_url: window.location.pathname
      //   };
      //   if(!mainProductFormData.properties) mainProductFormData.properties = {};
      //   mainProductFormData.properties._haveInstallationProduct = "true";
      //   mainProductFormData.properties._uniqId = uniqId;
      //   cartItems.installationProduct = {
      //     id: hiddenInstallationProduct.dataset.id,
      //     quantity: 1,
      //     properties:{
      //       _intallationproduct: true,
      //       _uniqId: uniqId
      //     }
      //   };
      //   cartItems.mainProduct = mainProductFormData;
      //   body = cartItems;
      // }

      // this.makeReomveAndAddaction(body,evt,serializeFormJson,checkInstallationProduct);
    }

    makeReomveAndAddaction(bodyData,evt,serializeFormJson,checkInstallationProduct){

      fetch(`${routes.cart_url}`, { ...fetchConfig('javascript') })
        .then((response) => response.json())
        .then((cart) => {
          
          let matchItem = cart.items.filter(item => {
            if(document.querySelector('#upsellInstallation')){
              return (item.id == serializeFormJson.id && item.properties._haveInstallationProduct == checkInstallationProduct.toString());
            }
            // else{
            //  return (item.id == serializeFormJson.id); 
            // }
          })[0];
          
          
          if(matchItem){
            let updates = {};
            updates[matchItem.key] = 0;
            
            let inatallationProduct = cart.items.filter(item => {
              return (matchItem.key != item.key && item.properties._uniqId == matchItem.properties._uniqId);
            })[0];
            if(inatallationProduct) updates[inatallationProduct.key] = 0;

            if(checkInstallationProduct){
              if((!bodyData.mainProduct.selling_plan && !matchItem.selling_plan_allocation) || (bodyData.mainProduct.selling_plan && matchItem.selling_plan_allocation)) bodyData.mainProduct.quantity = parseInt(bodyData.mainProduct.quantity) + matchItem.quantity;
              bodyData = {
                items:[bodyData.installationProduct,bodyData.mainProduct],
                sections:bodyData.sections,
                sections_url:bodyData.sections_url
              }
            }else{
              if((!bodyData.selling_plan && !matchItem.selling_plan_allocation) || (bodyData.selling_plan && matchItem.selling_plan_allocation)) bodyData.quantity = parseInt(bodyData.quantity) + matchItem.quantity;
            }
            
            let body = JSON.stringify({updates:updates});

            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
              .then((response) => response.json())
              .then((data) => {
                this.makeAddtoCartAction(bodyData,evt);
              });
          }else{
            if(checkInstallationProduct){
              bodyData = {
                items:[bodyData.installationProduct,bodyData.mainProduct],
                sections:bodyData.sections,
                sections_url:bodyData.sections_url
              }
            }
            this.makeAddtoCartAction(bodyData,evt);
          }
        });
    }
    
    makeAddtoCartAction(body,evt){
      body = JSON.stringify(body);
      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
  
          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
  
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
  
          }));
          window.twitterEvent(parsedState);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('disabled');

        if(this.stickyBtn){
          this.stickyBtn.classList.remove('loading');
          this.stickyBtn.removeAttribute('disabled');
        }
        // if quickview, close modal
          
        if(evt.target.id == "product-form-main-product-quickview") {
           evt.target.closest("quick-view").close();
        }
        this.cartDrawer.open();
      });
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer__content',
          section: document.getElementById('cart-drawer__content').dataset.id,
          selector: '.cart-drawer__content',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }
  
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-form', ProductForm);
}